import { VehicleMake } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';

export interface VehicleMakesState extends EntityState<VehicleMake> {}

export const vehicleMakesAdapter: EntityAdapter<VehicleMake> = createEntityAdapter<VehicleMake>({
  selectId: (vehicleMake: VehicleMake) => vehicleMake.id
});

export const initialState: VehicleMakesState = vehicleMakesAdapter.getInitialState({ loading: true });
export const vehicleMakesSelector = createSelector(
  svcDropdownsFeatureSelector,
  (state: any) => state.vehicleMakes
);

export const { selectIds, selectEntities, selectAll, selectTotal } = vehicleMakesAdapter.getSelectors(
  vehicleMakesSelector
);
